import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RecursiveCommessa, Commessa, OrdineLavoro } from '../def/structures';
import { DBFirestoreService } from '../dbfirestore.service';
import { ODLErrorMessages, EventEditCommessa, BatchOperation, EventDeleteOrdine, EventOrdine, EventDeleteCommessa } from '../def/types';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-odl-edit',
    templateUrl: './odl-edit.component.html',
    styleUrls: ['./odl-edit.component.scss']
})
export class OdlEditComponent implements OnInit, OnDestroy {

    public addnew = false;
    public recursive_commessa: RecursiveCommessa;

    private unsubscribe$ = new Subject<void>();

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private db: DBFirestoreService,
    ) { }

    ngOnInit() {
        // this.db.getCommessaById(this.route.snapshot.params.id).subscribe( result => this.commessa = result );
        this.db.getRecursiveCommessaById(this.route.snapshot.params.id)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(result => this.recursive_commessa = result);
    }

    onSave(eventUpdate: EventEditCommessa) {

        const commessa: Partial<Commessa> = eventUpdate.data;
        const eventoOrdini: EventOrdine[] = eventUpdate.ordini;

        const ops: BatchOperation[] = [];

        eventoOrdini.forEach( eventOrdine => {
            if (eventOrdine.type === 'delete') {
                commessa.numero_ordini--;
                const doc = {
                    id: eventOrdine.id,
                    rif_commessa: commessa.id,
                }
                ops.push(this.db.batchDeleteOrdine(doc));
            }
            if (eventOrdine.type === 'add') {
                commessa.numero_ordini++;
                // Per eseguire inserimento in modalità batch è necessario fornire manualmente un id
                const pseudoId = commessa.id + '-' +
                    eventOrdine.date.getFullYear().toString() +
                    (eventOrdine.date.getMonth() + 1).toString().padStart(2, '0') +
                    eventOrdine.date.getDate().toString().padStart(2, '0');


                const defaultValues = eventOrdine.default || {};

                const doc: OrdineLavoro = {
                    id: pseudoId,
                    confermato: false,
                    durata_prevista: '',
                    giorno_ora: eventOrdine.date,
                    attrezzi: '',
                    indirizzo: defaultValues.indirizzo || '',
                    localita: defaultValues.localita || '',
                    note: defaultValues.note || '',
                    persona_riferimento: defaultValues.persona_riferimento || '',
                    autista: null,
                    caposquadra: null,
                    mezzo: null,
                    telefono: defaultValues.telefono || '',
                    rif_commessa: commessa.id,

                    tipo_intervento: commessa.tipo_intervento ? commessa.tipo_intervento.id : null,
                    tipo_cliente: commessa.tipo_cliente ? commessa.tipo_cliente.id : null,
                };
                ops.push(this.db.batchAddOrdine(doc));
            }

            if (eventOrdine.type === 'edit') {
                // const doc = eventOrdine.data as OrdineLavoro;
                const doc = eventOrdine.data;
                doc.id = eventOrdine.id;
                doc.rif_commessa = commessa.id;
                doc.tipo_cliente = commessa.tipo_cliente ? commessa.tipo_cliente.id : null;
                doc.tipo_intervento = commessa.tipo_intervento ? commessa.tipo_intervento.id : null;
                ops.push(this.db.batchUpdateOrdine(<OrdineLavoro>doc));
            }
        });

        ops.push( this.db.batchUpdateCommessa(commessa) );

        this.db.batch(ops).then(() => {
            this.router.navigate(['/schedule']);
        }).catch(error => {
            this.onError({ title: 'Errore aggiornamento', details: error });
        })

        if ( !this.db.online ) {
            this.router.navigate(['/schedule']);
        }

    }

    onDelete(eventDelete: EventDeleteCommessa) {

        // const confirmed = confirm("Stai per eliminare questa commessa e tutti i rapportini collegati. Confermi la cancellazione?");
        const confirmed: boolean = confirm("Attenzione: l'eliminazione dell'ordine riguarda tutte le settimane. Eliminare l'ordine?");
        const id_commessa: string = eventDelete.id;
        const eventoOrdini: EventDeleteOrdine[] = eventDelete.ordini;

        if ( confirmed ) {
            const ops: BatchOperation[] = [];
            ops.push(this.db.batchDeleteCommessa({ id: id_commessa }));
            eventoOrdini.forEach((eventoOrdine: EventDeleteOrdine) => {
                ops.push(this.db.batchDeleteOrdine({
                    id: eventoOrdine.id,
                    rif_commessa: id_commessa
                }));
            });
            this.db.batch(ops).then(() => {
                this.router.navigate(['/schedule']);
            }).catch(error => {
                this.onError({ title: 'Errore cancellazione', details: error });
            });

            if ( !this.db.online ) {
                this.router.navigate(['/schedule']);
            }
        }
    }

    onError(error: ODLErrorMessages) {
        alert(error.title);
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

}
